import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: translations.en });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("civic.lang") || "en";
  });

  useEffect(() => {
    window.localStorage.setItem("civic.lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = translations[lang] || translations.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
